import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { BuyButton } from './BuyButton';
const highlights = ['Plan completo de 7 días', 'Worksheets imprimibles', 'Escrito en español'];
export function Hero() {
  return <section className="w-full bg-cream px-5 pb-16 pt-10 sm:px-8 sm:pb-24 sm:pt-16" data-id="element-41" data-mp="9igwhbqjful8">
      <div className="mx-auto grid max-w-6xl items-center gap-12 lg:grid-cols-[1.05fr_0.95fr] lg:gap-16" data-id="element-42" data-mp="4njng4t9dl8c">
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-43" data-mp="127ect9b6vhbc">
          <p className="mb-5 inline-block border border-sand bg-linen px-4 py-1.5 text-[0.7rem] uppercase tracking-[0.22em] text-terracotta" data-id="element-44" data-mp="s9qa9x7cd5im">
            Ebook en español
          </p>
          <h1 className="font-serif text-[2.75rem] leading-[1.05] text-clay sm:text-6xl lg:text-7xl" data-id="element-45" data-mp="3d2bidl8y6rtf">
            Organiza Tu Vida
            <span className="mt-1 block text-terracotta" data-id="element-46" data-mp="384jpop0hb1o6">en 7 Días</span>
          </h1>
          <p className="mt-6 max-w-lg border-l-2 border-sand pl-5 text-lg leading-relaxed text-cocoa sm:text-xl" data-id="element-47" data-mp="3j9agbasosm43">
            Un plan simple, práctico y amoroso para recuperar el orden, la calma
            y el control de tu vida diaria.
          </p>

          <ul className="mt-8 flex flex-wrap gap-x-6 gap-y-3" data-id="element-48" data-mp="3e8mtz2fektg7">
            {highlights.map(item => <li key={item} className="flex items-center gap-2 text-sm text-cocoa" data-id="element-49" data-mp="30hrjxmt646b1">
                <CheckIcon className="h-4 w-4 shrink-0 text-terracotta" aria-hidden="true" data-id="element-50" data-mp="3599jc6fjlytw" />
                {item}
              </li>)}
          </ul>

          <div className="mt-10 flex flex-col items-start gap-4 sm:flex-row sm:items-center" data-id="element-51" data-mp="2qhqx3qw3b823">
            <BuyButton data-id="element-52" data-mp="2vgu1d948xa90" />
            <p className="text-sm text-cocoa/80" data-id="element-53" data-mp="2hjf63nrba894">
              <span className="mr-2 line-through opacity-60" data-id="element-54" data-mp="2hjoz7k7nkvj1">$19 USD</span>
              Hoy desde <strong className="font-semibold text-terracotta" data-id="element-55" data-mp="2ljpe15ynz8qm">$9 USD</strong>
            </p>
          </div>
          <p className="mt-4 text-xs uppercase tracking-[0.18em] text-clay" data-id="element-56" data-mp="s2tbjfzvhzn3">
            Descarga inmediata · Oferta por tiempo limitado
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.12,
        ease: [0.22, 1, 0.36, 1]
      }} className="relative mx-auto w-full max-w-md" data-id="element-57" data-mp="ibgmsx9dfpla">
          <div className="absolute -bottom-4 -right-4 hidden h-full w-full border border-sand sm:block" aria-hidden="true" data-id="element-58" data-mp="1ayjilhmnxm7u" />
          <img src="https://cdn.magicpatterns.com/uploads/uqsWVeQrLkavzRZUhd5Rec/private_openrouter-generated-image-1784660615112.png" alt="Portada del ebook Organiza Tu Vida en 7 Días, con una mujer escribiendo en su cuaderno en una cocina ordenada" className="relative w-full shadow-[0_24px_60px_-30px_rgba(59,46,39,0.5)]" data-id="element-59" data-mp="112g7vndqwf9a" />
        </motion.div>
      </div>
    </section>;
}